"use strict";
exports.__esModule = true;
exports.isOpenAPI = void 0;
function isOpenAPI(value) {
    return (typeof value === 'object' &&
        'openapi' in value &&
        typeof value['openapi'] === 'string' &&
        value['openapi'].match(/^3\.0\.\d(-.+)?$/) != null);
}
exports.isOpenAPI = isOpenAPI;
